const whyItems = [
  {
    icon: '⚡',
    title: 'Speed to Market',
    desc: 'Onboard in 48 hours. No warehouse lease, no hiring, no setup.',
  },
  {
    icon: '💡',
    title: 'Technology First',
    desc: 'Real-time data, automated workflows, intelligent routing. Every operation powered by our platform.',
  },
  {
    icon: '📈',
    title: 'Scales With You',
    desc: 'From 50 orders a month to 50,000. Our infrastructure flexes without cost surprises.',
  },
  {
    icon: '🛡',
    title: 'Zero Risk Model',
    desc: 'Pay-as-you-use pricing. No long-term contracts, no idle space costs.',
  },
];

const testimonials = [
  {
    initials: 'AO',
    quote: 'THL transformed our order fulfillment. We went from 3-day shipping to same-day delivery without hiring a single extra person.',
    name: 'Adaeze Okonkwo',
    role: 'CEO, BrightSkin Nigeria',
  },
  {
    initials: 'CB',
    quote: 'We scaled from 200 to 2,000 orders per month without changing anything on our end. The inventory accuracy is exceptional.',
    name: 'Chukwuemeka Balogun',
    role: 'Head of Operations, ShopEase Lagos',
  },
  {
    initials: 'CI',
    quote: 'THL does not operate with bottlenecks, which ensures speedy service delivery. Each time we ask for something unique in for business, they are always flexible to getting it done, with minimal issues. It has been a pleasure working with THL.',
    name: 'Chijindun Ikpa',
    role: 'Hudson Brand',
  },
];

export default function WhyAndTestimonialsSection() {
  return (
    <>
      {/* Why THL */}
      <section className="py-24 px-6" style={{ background: '#0c0c14' }}>
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="eyebrow">Why THL</p>
            <h2 className="section-heading mb-2">The Smarter Way to Fulfill</h2>
            <p className="section-lead max-w-xl">
              We eliminate logistics complexity so you can focus entirely on growing your business.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {whyItems.map(item => (
              <div key={item.title} className="bg-thl-dark3 border border-thl-border rounded-xl p-6 hover:border-thl-red/30 transition-all duration-200 text-center">
                <div className="text-3xl mb-4 flex items-center justify-center">{item.icon}</div>
                <h3 className="text-white font-bold text-base mb-2">{item.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 px-6" style={{ background: '#0A0A0F' }}>
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <p className="eyebrow">Testimonials</p>
            <h2 className="section-heading">Trusted by Growing Brands</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {testimonials.map(t => (
              <div key={t.name} className="bg-thl-dark3 border border-thl-border rounded-xl p-6 hover:border-thl-red/20 transition-all duration-200">
                <div className="w-10 h-10 rounded-full bg-thl-red flex items-center justify-center text-white font-bold text-sm mb-4">
                  {t.initials}
                </div>
                <div className="text-thl-red mb-3 text-sm">★★★★★</div>
                <p className="text-white/70 text-sm leading-relaxed mb-5">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="text-white font-semibold text-sm">{t.name}</div>
                <div className="text-white/40 text-xs mt-0.5">{t.role}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
